import styled from "styled-components";

const InvestmentManagerHolder = styled.div`
    display: flex;
    gap: 5px;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    position: relative;
    min-width: 0;
    max-width: 100%;

    .percentage-input-container {
        display: flex;
        align-items: center;
        position: relative;
        width: 80px;
        flex: 0 0 auto;
    }

    /* Tablet / mobile: el input de moneda mantiene ancho suficiente para "$ARS 7.491,06" */
    @media (max-width: 991px) {
        > div:first-child .ant-input-number {
            width: 130px !important;
        }
    }
`;

export default InvestmentManagerHolder;
